import { FormControlLabel } from "@mui/material";
import { ArrowLeft } from "feather-icons-react/build/IconComponents";
import { t } from "i18next";
import { useContext, useEffect, useRef, useState } from "react";
import { QuestionCircleFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import API from "../../API/newIndex";
import { ChangePathContext, PlanPermission } from "../../App";
import Breadcrumbs from "../../controllers/breadCrumbs";
import ImageUploader from "../../controllers/ImageUploader";
import MuiSwitch from "../../controllers/MuiSwitch";
import { parentNavigate } from "../../controllers/ParentNavigate";
import ColorPicker from "../Color/ColorPicker";
import Notification from "../Notification";
import SendMail from "./SendMail";
import {
  ButtonComponent,
  DetailsComponent,
  InputComponent,
} from "@shopeasy-dashboard-ui/ui-library";
import TextareaComponent from "../FormInput/TextareaComponent";

const Newsletter = () => {
  const colorPickerRef = useRef(null);
  const { saveChanges, setSaveChanges } = useContext(ChangePathContext);
  const navigate = useNavigate();
  const [newsletter, setnewsletter] = useState({
    newsletter_button_color: "#000000",
    newsletter_button_hover_color: "#818181",
    newsletter_button_hover_text_color: "#000000",
    newsletter_button_text: "",
    newsletter_button_text_color: "#818181",
    newsletter_description:
      "Subscribe to our newsletters now and stay up to date with new collections, latest lookbooks and exclusive offers",
    newsletter_image: "",
    newsletter_title: "Sign up for newsletter",
    newsletter_social_icons: true,
    newsletter_bg_color: "#ffffff",
    newsletter_description_color: "#aaaaaa",
    newsletter_title_color: "#000000",
  });
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [loader, setLoader] = useState(false);
  const { planPermission, setPlanPermission } = useContext(PlanPermission);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setOpenState("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const HandleClientInfo = async () => {
    try {
      let ApiCall = await API({ url: `/admin/newsletter/GetNewslatter`, method: "get" });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        const result = ApiCall?.data;
        setnewsletter({
          ...result?.data?.newsletter,
          newsletter_button_color: result?.data?.newsletter?.newsletter_button_color
            ? result?.data?.newsletter?.newsletter_button_color
            : "#000000",
          newsletter_button_hover_color: result?.data?.newsletter?.newsletter_button_hover_color
            ? result?.data?.newsletter?.newsletter_button_hover_color
            : "#818181",
          newsletter_button_hover_text_color: result?.data?.newsletter
            ?.newsletter_button_hover_text_color
            ? result?.data?.newsletter?.newsletter_button_hover_text_color
            : "#000000",
          newsletter_button_text_color: result?.data?.newsletter?.newsletter_button_text_color
            ? result?.data?.newsletter?.newsletter_button_text_color
            : "#818181",
          newsletter_description: result?.data?.newsletter?.newsletter_description
            ? result?.data?.newsletter?.newsletter_description
            : "Subscribe to our newsletters now and stay up to date with new collections, latest lookbooks and exclusive offers",
          newsletter_image: result?.data?.newsletter?.newsletter_image
            ? result?.data?.newsletter?.newsletter_image
            : "",
          newsletter_title: result?.data?.newsletter?.newsletter_title
            ? result?.data?.newsletter?.newsletter_title
            : "Sign up for newsletter",
          newsletter_social_icons: result?.data?.newsletter?.newsletter_social_icons,
          newsletter_bg_color: result?.data?.newsletter?.newsletter_bg_color
            ? result?.data?.newsletter?.newsletter_bg_color
            : "#ffffff",
          newsletter_description_color: result?.data?.newsletter?.newsletter_description_color
            ? result?.data?.newsletter?.newsletter_description_color
            : "#aaaaaa",
          newsletter_title_color: result?.data?.newsletter?.newsletter_title_color
            ? result?.data?.newsletter?.newsletter_title_color
            : "#000000",
        });
      }
    } catch (error) {
      if (error?.response?.status === 882) {
        setPlanPermission({ isPlanPermissions: false, forModule: "category" });
      }
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    HandleClientInfo();
  }, []);

  const handleSetImage = (value) => {
    setnewsletter({ ...newsletter, newsletter_image: value });
    setIsChange(true);
  };

  const [btnLoading, setBtnLoading] = useState(false);
  const HandleSubmit = async (e) => {
    e.preventDefault();
    setBtnLoading(true);
    try {
      const payload = {
        clientInfo: {
          newsletter,
        },
      };
      let ApiCall = await API({
        url: "/admin/client/updateClient",
        method: "put",
        data: payload,
      });
      if (ApiCall.status === 200 || ApiCall.status === 304) {
        HandleClientInfo();
        setSaveChanges({
          isUnsaveChanges: false,
          showChangesPopup: false,
          backLink: "/newsletter",
          title: "newsletter",
        });
        setIsNotification(true);
        setNotificationMsg("Newsletter updated successfully");
        setSeverity("success");
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
    setBtnLoading(false);
  };

  const handleClose = () => {
    setIsNotification(false);
    setNotificationMsg("");
    setSeverity("");
  };

  const [isChange, setIsChange] = useState(false);
  useEffect(() => {
    if (isChange) {
      setSaveChanges({
        backLink: "/dashboard",
        isUnsaveChanges: true,
        showChangesPopup: false,
        title: "newsletter",
      });
    }
  }, [isChange]);

  const checkChanges = () => {
    if (isChange) {
      setSaveChanges({
        isUnsaveChanges: true,
        showChangesPopup: true,
        backLink: "/dashboard",
        title: "newsletter",
      });
    } else {
      parentNavigate("/dashboard");
    }
  };

  const [openState, setOpenState] = useState();
  const handleColorChange = (value) => {
    if (openState === "newsletter_title_color") {
      setnewsletter({ ...newsletter, newsletter_title_color: value });
    } else if (openState === "newsletter_description_color") {
      setnewsletter({ ...newsletter, newsletter_description_color: value });
    } else if (openState === "newsletter_button_color") {
      setnewsletter({ ...newsletter, newsletter_button_color: value });
    } else if (openState === "newsletter_button_text_color") {
      setnewsletter({ ...newsletter, newsletter_button_text_color: value });
    } else if (openState === "newsletter_button_hover_color") {
      setnewsletter({ ...newsletter, newsletter_button_hover_color: value });
    } else if (openState === "newsletter_button_hover_text_color") {
      setnewsletter({
        ...newsletter,
        newsletter_button_hover_text_color: value,
      });
    } else if (openState === "newsletter_bg_color") {
      setnewsletter({ ...newsletter, newsletter_bg_color: value });
    }
    setIsChange(true);
  };

  const handleCloseColor = () => {
    setOpenState("");
  };

  return (
    <>
      {isNotification && notificationMsg && (
        <Notification message={notificationMsg} close={handleClose} severity={severity} />
      )}
      <div className="h-auto overflow-y-auto pb-[50px] pt-5">
        <div className="px-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="flex items-center space-x-2">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  checkChanges();
                }}
                className="back-arrow -ml-3.5"
              >
                <ArrowLeft />
              </button>
              <div className="flex-1 min-w-0">
                <Breadcrumbs
                  crumbs={[
                    { name: t("lang_dashboard"), path: `/dashboard` },
                    { name: t("lang_newsletter"), path: "/newsletter" },
                  ]}
                />
                <div className="flex flex-wrap items-center gap-2 sm:gap-3 mt-1">
                  <h4 className="text-xl md:text-2xl font-semibold text-primary">
                    {t("lang_newsletter")}
                  </h4>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://help.shopeasy.ai/articles/newsletter-management"
                    className="how-it-works !m-0"
                  >
                    <QuestionCircleFill className="me-1.5" />
                    {t("lang_how_to_use")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-[20px]">
          <div className="w-full lg:w-[70%] xl:w-[60%] mx-auto space-y-4">
            <form onKeyDown={(e) => e.key === "Enter" && e.preventDefault()} className="space-y-4">
              <DetailsComponent
                open={true}
                hasHr={false}
                showChevron={false}
                title={t("lang_Store_Newslatter_Content")}
                subtitle={t("lang_Store_Newslatter_Content_Details")}
              >
                <div className="w-full mb-4">
                  <label
                    className="flex table-text text-[13px] font-medium mb-1"
                    htmlFor="product_name"
                  >
                    {t("lang_Newsletter_Image")}
                  </label>
                  <ImageUploader
                    alreadyImage={newsletter?.newsletter_image}
                    handleSetImage={handleSetImage}
                    folder="newsletter"
                    format="image"
                  />
                </div>
                <div>
                  <div className="grid table-text grid-cols-1 gap-5 md:grid-cols-2 mb-4">
                    <div className="w-full">
                      <InputComponent
                        id="newsletter_title"
                        name="newsletter_title"
                        label={t("lang_Newsletter_Title")}
                        required
                        value={newsletter.newsletter_title}
                        onChange={(e) => {
                          setnewsletter({
                            ...newsletter,
                            newsletter_title: e.target.value,
                          });
                          setIsChange(true);
                        }}
                        placeholder="e.g. SUBSCRIBE"
                      />
                    </div>
                    <div className="w-full">
                      <InputComponent
                        id="newsletter_button_text"
                        name="newsletter_button_text"
                        label={t("lang_Newsletter_Button_Text")}
                        value={newsletter.newsletter_button_text}
                        onChange={(e) => {
                          setnewsletter({
                            ...newsletter,
                            newsletter_button_text: e.target.value,
                          });
                          setIsChange(true);
                        }}
                        placeholder="e.g. SUBSCRIBE"
                      />
                    </div>
                  </div>
                  <div className="w-full mb-4">
                    <TextareaComponent
                      id="newsletter_description"
                      name="newsletter_description"
                      label={t("lang_Newsletter_Description")}
                      required
                      value={newsletter.newsletter_description}
                      onChange={(e) => {
                        setnewsletter({
                          ...newsletter,
                          newsletter_description: e.target.value,
                        });
                        setIsChange(true);
                      }}
                      placeholder="e.g. SUBSCRIBE"
                      rows={3}
                    />
                  </div>
                  <div className="w-full border main-border-color px-4 py-2 flex items-center justify-between rounded-[6px]">
                    <p className="text-[13px] table-text font-medium me-2 mb-0">
                      {t("lang_Newsletter_Social_Icons")}
                    </p>
                    <div className="flex justify-end items-center">
                      <FormControlLabel
                        checked={newsletter?.newsletter_social_icons}
                        control={<MuiSwitch />}
                        onChange={() => {
                          setnewsletter({
                            ...newsletter,
                            newsletter_social_icons: !newsletter.newsletter_social_icons,
                          });
                          setIsChange(true);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </DetailsComponent>
              <DetailsComponent
                open
                hasHr={false}
                title={t("lang_Store_Newslatter_Appearance")}
                subtitle={t("lang_Store_Newslatter_Appearance_Details")}
              >
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                  <div className="w-full">
                    <label htmlFor="newsletter_button_hover_color" className="text-[var(--primary-text-color)] font-medium text-[13px]">
                      {t("lang_Newsletter_Title_Color")}
                    </label>
                    <div className="relative mt-1">
                      <div
                        onClick={() => setOpenState("newsletter_title_color")}
                        className="cursor-pointer flex items-center border main-border-color p-1.5 mb-2 rounded-[6px] space-x-2"
                      >
                        <div
                          className="w-[30px] shadow h-[30px] rounded-[6px] cursor-pointer"
                          style={{
                            backgroundColor: newsletter?.newsletter_title_color,
                          }}
                        ></div>
                        <span className="text-sm font-medium table-text">
                          {newsletter?.newsletter_title_color}
                        </span>
                      </div>
                      {openState === "newsletter_title_color" && (
                        <div ref={colorPickerRef}>
                          <ColorPicker
                            handleChange={handleColorChange}
                            setting={newsletter?.newsletter_title_color}
                            handleCloseColor={handleCloseColor}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full">
                    <label htmlFor="newsletter_button_hover_text_color" className="text-[var(--primary-text-color)] font-medium text-[13px]">
                      {t("lang_Newsletter_Description_Color")}:
                    </label>
                    <div className="relative mt-1">
                      <div
                        onClick={() => setOpenState("newsletter_description_color")}
                        className="cursor-pointer flex items-center border main-border-color p-1.5 mb-2 rounded-[6px] space-x-2"
                      >
                        <div
                          className="w-[30px] shadow h-[30px] rounded-[6px] cursor-pointer"
                          style={{
                            backgroundColor: newsletter?.newsletter_description_color,
                          }}
                        ></div>
                        <span className="text-sm font-medium table-text">
                          {newsletter?.newsletter_description_color}
                        </span>
                      </div>
                      {openState === "newsletter_description_color" && (
                        <div ref={colorPickerRef}>
                          <ColorPicker
                            handleChange={handleColorChange}
                            setting={newsletter?.newsletter_description_color}
                            handleCloseColor={handleCloseColor}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full">
                    <label htmlFor="newsletter_button_color" className="text-[var(--primary-text-color)] font-medium text-[13px]">
                      {t("lang_Newsletter_Button_Color")}
                    </label>
                    <div className="relative mt-1">
                      <div
                        onClick={() => setOpenState("newsletter_button_color")}
                        className="cursor-pointer flex items-center border main-border-color p-1.5 mb-2 rounded-[6px] space-x-2"
                      >
                        <div
                          className="w-[30px] shadow h-[30px] rounded-[6px] cursor-pointer"
                          style={{
                            backgroundColor: newsletter?.newsletter_button_color,
                          }}
                        ></div>
                        <span className="text-sm font-medium table-text">
                          {newsletter?.newsletter_button_color}
                        </span>
                      </div>
                      {openState === "newsletter_button_color" && (
                        <div ref={colorPickerRef}>
                          <ColorPicker
                            handleChange={handleColorChange}
                            setting={newsletter?.newsletter_button_color}
                            handleCloseColor={handleCloseColor}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full">
                    <label htmlFor="newsletter_button_text_color" className="text-[var(--primary-text-color)] font-medium text-[13px]">
                      {t("lang_Newsletter_Button_Text_Color")}
                    </label>
                    <div className="relative mt-1">
                      <div
                        onClick={() => setOpenState("newsletter_button_text_color")}
                        className="cursor-pointer flex items-center border main-border-color p-1.5 mb-2 rounded-[6px] space-x-2"
                      >
                        <div
                          className="w-[30px] shadow h-[30px] rounded-[6px] cursor-pointer"
                          style={{
                            backgroundColor: newsletter?.newsletter_button_text_color,
                          }}
                        ></div>
                        <span className="text-sm font-medium table-text">
                          {newsletter?.newsletter_button_text_color}
                        </span>
                      </div>
                      {openState === "newsletter_button_text_color" && (
                        <div ref={colorPickerRef}>
                          <ColorPicker
                            handleChange={handleColorChange}
                            setting={newsletter?.newsletter_button_text_color}
                            handleCloseColor={handleCloseColor}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full">
                    <label htmlFor="newsletter_button_hover_color" className="text-[var(--primary-text-color)] font-medium text-[13px]">
                      {t("lang_Newsletter_Button_Hover_Color")}
                    </label>
                    <div className="relative mt-1">
                      <div
                        onClick={() => setOpenState("newsletter_button_hover_color")}
                        className="cursor-pointer flex items-center border main-border-color p-1.5 mb-2 rounded-[6px] space-x-2"
                      >
                        <div
                          className="w-[30px] shadow h-[30px] rounded-[6px] cursor-pointer"
                          style={{
                            backgroundColor: newsletter?.newsletter_button_hover_color,
                          }}
                        ></div>
                        <span className="text-sm font-medium table-text">
                          {newsletter?.newsletter_button_hover_color}
                        </span>
                      </div>
                      {openState === "newsletter_button_hover_color" && (
                        <div ref={colorPickerRef}>
                          <ColorPicker
                            handleChange={handleColorChange}
                            setting={newsletter?.newsletter_button_hover_color}
                            handleCloseColor={handleCloseColor}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full">
                    <label htmlFor="newsletter_button_hover_text_color" className="text-[var(--primary-text-color)] font-medium text-[13px]">
                      {t("lang_Newsletter_Button_Hover_Text_Color")}
                    </label>
                    <div className="relative mt-1">
                      <div
                        onClick={() => setOpenState("newsletter_button_hover_text_color")}
                        className="cursor-pointer flex items-center border main-border-color p-1.5 mb-2 rounded-[6px] space-x-2"
                      >
                        <div
                          className="w-[30px] shadow h-[30px] rounded-[6px] cursor-pointer"
                          style={{
                            backgroundColor: newsletter?.newsletter_button_hover_text_color,
                          }}
                        ></div>
                        <span className="text-sm font-medium table-text">
                          {newsletter?.newsletter_button_hover_text_color}
                        </span>
                      </div>
                      {openState === "newsletter_button_hover_text_color" && (
                        <div ref={colorPickerRef}>
                          <ColorPicker
                            handleChange={handleColorChange}
                            setting={newsletter?.newsletter_button_hover_text_color}
                            handleCloseColor={handleCloseColor}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full">
                    <label htmlFor="newsletter_button_hover_color" className="text-[var(--primary-text-color)] font-medium text-[13px]">
                      {t("lang_Newsletter_Background_Color")}
                    </label>
                    <div className="relative mt-1">
                      <div
                        onClick={() => setOpenState("newsletter_bg_color")}
                        className="cursor-pointer flex items-center border main-border-color p-1.5 mb-2 rounded-[6px] space-x-2"
                      >
                        <div
                          className="w-[30px] shadow h-[30px] rounded-[6px] cursor-pointer"
                          style={{
                            backgroundColor: newsletter?.newsletter_bg_color,
                          }}
                        ></div>
                        <span className="text-sm font-medium table-text">
                          {newsletter?.newsletter_bg_color}
                        </span>
                      </div>
                      {openState === "newsletter_bg_color" && (
                        <div ref={colorPickerRef}>
                          <ColorPicker
                            handleChange={handleColorChange}
                            setting={newsletter?.newsletter_bg_color}
                            handleCloseColor={handleCloseColor}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </DetailsComponent>
            </form>
          </div>
        </div>
        <div className="flex items-center shadow fixed justify-between w-full bottom-[0px] z-50 secondary-bg-color border-t main-border-color p-3 left-0">
          <div className="w-full flex items-center justify-between lg:w-[70%] xl:w-[60%] mx-auto">
            <div className="w-full flex justify-end">
              <ButtonComponent
                variant="primary"
                size="md"
                loading={btnLoading}
                onClick={(e) => HandleSubmit(e)}
              >
                {btnLoading ? t("lang_Saving") : t("lang_Apply_Changes")}
              </ButtonComponent>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newsletter;
